
import { ContactEntity } from '../contact/contact.options';
import { Entity } from '../entity';
import { EntitySubStatus } from '../entity.status/entity.status';
import { Site, SiteTiny } from '../shared/site';
import { Attachment } from '../shared/attachment';
import { AssetLinkRequest, AssetReparentRequest } from './asset.request';

export enum AssetKind {
    Default = 'Default',
    Equipment = 'Equipment',
}

export enum AssetViewVariant {
    CustomerAssets = 'customer-assets',
    LegacyAssets = 'legacy-assets',
}

export interface AssetTypeEntity extends Entity {
    sortOrder: number;
}

export interface Asset extends Entity {
    kind?: AssetKind;
    assetNumber?: string;
    assetType: AssetTypeEntity;
    site: SiteTiny;
    customer: ContactEntity;
    parent?: Entity;
    barcode?: string;
    serial?: string;
    model?: string;
    integrationId?: string;
    customFields?: any;
    attachments?: Attachment[];
    createdAt?: Date;
    createdBy?: Entity;
    updatedAt?: Date;
    updatedBy?: Entity;
    children?: Entity[];
    lastServicedJob?: string;
    lastServiceOn?: Date;
    selected?: boolean;
    linked?: boolean;
    qrCode?: string;
    childrenCount?: number;
    allowScheduling?: boolean;
    crew?: Entity[];
    tags?: Entity[];

    status?: EntitySubStatus;
    stockLocation?: boolean;
}

export interface AssetWithLink extends Asset {
    assetLinkId: string;
}

export enum EmbeddedMode {
    AssetRegister = 'Asset Register',
    AssetDetails = 'Asset Details',
    Job = 'Job',
    NewJob = 'New Job',
    Crm = 'Crm',
    Picker = 'Picker',
    RecurringJob = 'Recurring Job',
    Site = 'Site'
}

export interface AssetMetadata {
    embeddedMode: EmbeddedMode;
    jobId: string;
    customer: ContactEntity;
    selectedSite?: Site;
    excludeAssetIds?: string[];
}

export enum AssetStatusSystemName {
    Active = 'Active',
    Inactive = 'Inactive',
}

export type AssetCommands =
    {
        commandId: 'Reparent',
        data: AssetReparentRequest
    }
    | {
        commandId: 'LinkToJob',
        data: AssetLinkRequest
    };